import ImportContactIcon from '@material-ui/icons/ImportContacts';
import * as React from 'react';
import { NavUrls } from '../layoutConstants';
import { MenuLink } from '../MenuLink';

interface ITargetedCatalogNavProps {
  menuClassName?: string;
  onNavClick: () => any;
  isActive: boolean;
}

let TargetedCatalogNav: React.FunctionComponent<ITargetedCatalogNavProps> = ({
  menuClassName,
  onNavClick,
  isActive
}) => {
  return (
    <MenuLink
      icon={<ImportContactIcon />}
      to={NavUrls.targetedCatalog}
      label="Targeted Catalog"
      menuClassName={menuClassName}
      onNavClick={onNavClick}
      isActive={isActive}
    />
  );
};

TargetedCatalogNav = React.memo<ITargetedCatalogNavProps>(TargetedCatalogNav);
export { TargetedCatalogNav };
